/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface AppSurveyInterface {
  "key"?: string;
  "title"?: string;
  "description"?: string;
  "done"?: boolean;
  "doneDate"?: string;
  "lastModifiedDate"?: string;
  "form"?: any;
  "id"?: any;
  "patientId"?: any;
  patient?: Patient;
}

export class AppSurvey implements AppSurveyInterface {
  "key": string;
  "title": string;
  "description": string;
  "done": boolean;
  "doneDate": string;
  "lastModifiedDate": string;
  "form": any;
  "id": any;
  "patientId": any;
  patient: Patient;
  constructor(data?: AppSurveyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AppSurvey`.
   */
  public static getModelName() {
    return "AppSurvey";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AppSurvey for dynamic purposes.
  **/
  public static factory(data: AppSurveyInterface): AppSurvey{
    return new AppSurvey(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AppSurvey',
      plural: 'AppSurveys',
      path: 'AppSurveys',
      idName: 'id',
      properties: {
        "key": {
          name: 'key',
          type: 'string'
        },
        "title": {
          name: 'title',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "done": {
          name: 'done',
          type: 'boolean'
        },
        "doneDate": {
          name: 'doneDate',
          type: 'string',
          default: 'null'
        },
        "lastModifiedDate": {
          name: 'lastModifiedDate',
          type: 'string',
          default: 'null'
        },
        "form": {
          name: 'form',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
